import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';

@Component({
  selector: 'app-rendition-delete-draft',
  templateUrl: './rendition-delete-draft.component.html',
  styleUrls: ['./rendition-delete-draft.component.scss'],
})
export class RenditionDeleteDraftComponent implements OnInit {
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: any;
  address = '';
  id = 0;

  ngOnInit(): void {
    if (this.value) {
      this.address = this.value.name;

      const dialogEvent = {
        isButtonActionDisabled: false,
        value: this.value.id,
      };

      this.dialogChange.emit(dialogEvent);
    }
  }
}
